import { useMemo } from 'react';
import { useGameStore } from '@/features/games/shared/store/game-store';
import { useUser } from '@/features/auth/shared/hooks/use-user';
import { isAlreadyPurchased } from '@/features/games/shared/helpers/is-already-purchased';

export function usePurchaseGate(sku: string) {
  const { loading: authLoading, authenticatedUser } = useUser();
  const purchaseHistory = useGameStore((s) => s.purchaseHistory);
  const historyLoaded = useGameStore((s) => s.historyLoaded);

  const isReady = useMemo(() => {
    if (authLoading) return false;

    if (!authenticatedUser) return true;

    return historyLoaded;
  }, [authLoading, authenticatedUser, historyLoaded]);

  const isPurchased = useMemo(() => {
    if (!isReady) return false;
    if (!authenticatedUser) return false;
    return isAlreadyPurchased(sku, purchaseHistory);
  }, [isReady, authenticatedUser, sku, purchaseHistory]);

  return { isReady, isPurchased };
}
